module.exports = __webpack_public_path__ + "img/desk_wide.359dd541.jpeg";